import styled from 'styled-components';

export const Wrapper = styled.div`
  .simplebar-vertical {
    background: var(--aluminium60);
    width: 4px;
    right: 0;
    border-radius: 3px;
    top: 8px;
    bottom: 8px;

    .simplebar-scrollbar:before {
      background: var(--carbone50);
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
    }
  }
`;
